import React from 'react';
import { BasicContainer, FlexRow } from '@minecraft.atoms';
import { Carousel } from '@minecraft.molecules';
import { FEATURE_FLAGS, useFeatureExperiment } from '@blocs.features-experiments';
import Icon from '@minecraft.icon';
import { TestimonialsIntegrationExperimentGroups } from '../enums/experimentGroups';
import { TestimonialCard } from './TestimonialCard';
import { usePaywallExperiments } from '../usePaywallExperiments';

export const TestimonialCarousel = React.memo(() => {
  const testimonialsIntegrationExperiment = useFeatureExperiment(FEATURE_FLAGS.EXPERIMENT_TESTIMONIALS_INTEGRATION);
  const { testimonials } = usePaywallExperiments();

  if (
    !testimonialsIntegrationExperiment ||
    testimonialsIntegrationExperiment === TestimonialsIntegrationExperimentGroups.Control
  ) {
    return null;
  }

  return (
    <FlexRow w="full" maxW="2xl" justifyContent="center" alignItems="center">
      <Carousel
        settings={{
          prevArrow: <Icon name="carousel-left" size="lg" />,
          nextArrow: <Icon name="carousel-right" size="lg" />,
        }}
        data-testid="testimonials-integration-carousel"
      >
        {testimonials.map((testimonial) => (
          <BasicContainer
            mt="8"
            key={testimonial.id ?? 'allison'}
            data-testid={`testimonial-${testimonial.id ?? 'allison'}`}
          >
            <TestimonialCard {...testimonial} withShadow={false} fullWidth />
          </BasicContainer>
        ))}
      </Carousel>
    </FlexRow>
  );
});
